<template>
  <a-card :bordered="false" title="用户标签" :headStyle="{fontSize:'18px'}">
    <search-page-view
      :col="3"
      ref="pageList"
      :columns="columns"
      :queryParams="queryParams"
      row-key="id"
      requestType="get"
      :enableSearch="false"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="operation">
        <a-input-search placeholder="请输入标签名称" @search="onSearch" style="max-width: 200px;"/>
        <a-button style="margin-left: 50px" type="primary" @click="toCreate">创建用户标签</a-button>
      </a-form-item>
      <span slot="action" slot-scope="rowItem">
          <a @click="showModal(rowItem.record)">编辑</a>
        <a-divider type="vertical"></a-divider>
        <a-popconfirm
          title="是否要删除当前标签？"
          @confirm="removeMark(rowItem.record)">
          <a>删除</a>
        </a-popconfirm>
      </span>
      <span slot="type" slot-scope="rowItem">{{ rowItem.text|userTagTypeName }}</span>
      <span slot="ruleType" slot-scope="rowItem">{{ rowItem.text|userTagRuleTypeName }}</span>
    </search-page-view>
    <a-modal title="编辑用户标签" v-model="visible" :footer="null">
      <a-form @submit="handleSubmit" :form="form">
        <a-form-item
          label=标签名称
          :wrapper-col="{ span: 12}"
          v-bind="formItemLayout">
          <a-input
            v-decorator="[
                'name',
                {rules: [{ required: true, message: '请输入标签名称' }],
                initialValue: name}
              ]"
            placeholder="请输入"/>
        </a-form-item>
        <a-form-item
          label="标签类型"
          v-bind="formItemLayout">
          <a-radio-group
            @change="onChangeRadio"
            v-decorator="[
              'type',
              {rules: [{ required: true, message: '请选择标签类型' }],
                initialValue:radioValue}
              ]">
            <a-radio v-for="item in radioList" :key="item.code" :value="item.code">{{ item.name }}</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="标签规则" v-if="radioValue !== 1" v-bind="formItemLayout">
          <p style="font-size:12px;">可根据不同规则配置自动标签，若该用户不再满足规则，则次日或次月会自动移除标签</p>
          <a-select
            style="width:150px;margin-right:20px;"
            @change="selectChanged"
            placeholder="请选择标签规则"
            v-decorator="[
              'ruleType',
              {initialValue:selectedValue}
            ]">
            <a-select-option v-for="item in selectedList" :key="item.code" :value="item.code">{{ item.name }}
            </a-select-option>
          </a-select>
          <span>{{ prefix }}</span>大于
          <a-input
            style="width:80px;margin: 0 20px;"
            v-decorator="[
              'ruleValue',
              {initialValue:ruleValue}
            ]"></a-input>
          <span>{{ suffix }}</span>,即标记
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 12, offset: 4}">
          <a-button htmlType="submit" type="primary">提交</a-button>
          <a-button @click="cancelButton" style="margin-left:10px">取消</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'UserLabel',
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 4
        },
        wrapperCol: {
          span: 20
        }
      },
      queryParams: {},
      visible: false,
      pageSize: '',
      pageNo: '',
      radioList: [],
      rowData: {},
      name: '',
      id: '',
      selectedValue: 1,
      ruleValue: 1,
      radioValue: 2,
      selectedList: [],
      prefix: '累计支付',
      suffix: '笔',
      form: this.$form.createForm(this),
      columns: [
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '标签名称',
          dataIndex: 'name'
        },
        {
          title: '用户数量',
          dataIndex: 'personNumber'
        },
        {
          title: '标签类型',
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' }
        },
        {
          title: '打标规则',
          dataIndex: 'ruleType',
          scopedSlots: { customRender: 'ruleType' }
        },
        {
          title: '创建时间',
          dataIndex: 'createTimeStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      loadPromise: params => this.getRequest(params)
    }
  },
  mounted() {
    //this.getRowData(this.id)
    this.radioList = this.getAppConstants().getUserTagType()
    this.selectedList = this.getAppConstants().getUserTagRuleType()
  },
  methods: {
    getRequest(params) {
      this.getLogUtils().logWithTag('-----params-----', params)
      this.pageNo = params.pageNo
      this.pageSize = params.pageSize
      return this.getHttpServices().getUserService().get('api/v2/member/tag/list', params)
    },
    toCreate() {
      this.$router.push({
        name: 'CreateUserTags',
        meta: { title: '创建用户标签' }
      })
    },
    onChangeRadio(e) {
      this.radioValue = e.target.value
      this.getLogUtils().logWithTag('this.radioValue:', this.radioValue)
    },
    onSearch(value) {
      this.getLogUtils().logWithTag('-----value-----', value)
      this.queryParams.name = value
      this.$refs.pageList.refresh()
    },
    //标签删除
    removeMark(record) {
      this.getHttpServices().getUserService().post('api/v2/member/tag/delete', {
        id: record.id,
        name: record.name,
        pageSize: this.pageSize,
        pageNo: this.pageNo
      })
        .then(res => {
          this.$message.success('成功删除')
          this.$refs.pageList.refresh()
        }).catch(reason => {
        this.$message.error('删除失败')
        this.showNetWorkErrorMessage(reason)
      })
    },
    showModal(record) {
      this.id = record.id
      this.selectedValue = record.ruleType
      this.name = record.name
      this.ruleValue = record.ruleValue
      this.radioValue = record.type
      this.visible = true
    },
    cancelButton() {
      this.visible = false
    },
    //提交
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.getLogUtils().logWithTag('Received values of form: ', values)
          this.getLogUtils().logWithTag('submitId', this.id)
          this.getHttpServices().getUserService().post('api/v2/member/tag/submit', {
            name: values.name,
            type: values.type,
            ruleType: values.ruleType,
            ruleValue: values.ruleValue,
            id: this.id
          })
            .then(res => {
              this.$message.success('提交成功')
              this.visible = false
              this.$refs.pageList.refresh()
            }).catch(reason => {
            this.$message.error('提交失败')
            this.showNetWorkErrorMessage(reason)
          })
        }
      })
    },
    selectChanged(value) {
      if (value == 1) {
        this.prefix = '累计支付'
        this.suffix = '笔'
      } else if (value == 2) {
        this.prefix = '累计支付'
        this.suffix = '元'
      } else if (value == 3) {
        this.prefix = '累计访问'
        this.suffix = '天'
      } else if (value == 4) {
        this.prefix = '平均单价'
        this.suffix = '元'
      } else {
        this.prefix = '平均支付'
        this.suffix = '笔'
      }
    }
  }
}
</script>
<style lang="less">
</style>